import { DOCUMENT } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { InstacitiListings } from "../instaciti-new.interface";
import { InstacitiNewService } from "../service/instaciti-new.service";

declare function LoadSlider(): any;
@Component({
  selector: "app-beauty-and-spa",
  templateUrl: "./beauty-and-spa.component.html",
  styleUrls: ["./beauty-and-spa.component.css"],
})
export class BeautyAndSpaComponent implements OnInit {
  filterData = [];
  headers = [];
  listing: InstacitiListings[];
  backupListing;
  arrFilter = [];
  constructor(
    @Inject(DOCUMENT) private document: any,
    private service: InstacitiNewService
  ) {
    document.body.classList.remove("mat-typography");
  }

  ngOnInit(): void {
    LoadSlider();
    this.getRestaurants();
    setTimeout(() => {
      this.getFiltersData();
    }, 1000);
  }

  getFiltersData() {
    const country = this.service.getSelectedCountry();
    this.service.GetFilterData(country, "beauty").subscribe((res) => {
      const category = JSON.parse(res.ManikJSon[0].JSon0[0].FilterJson);
      this.filterData = category.CatJson;
      this.filterData.forEach((element) => {
        this.headers = this.headers.concat(Object.keys(element));
      });
    });
  }

  getRestaurants() {
    this.service.getListings("100006").subscribe((res) => {
      this.listing = res.ManikJSon[0].JSon0;
      this.listing.forEach((element) => {
        if (element.PopularAttribs) {
          element.PopularAttribs = JSON.parse(element.PopularAttribs);
          element.PopularAttribs.forEach((element1, idx) => {
            if (element1.ID === "CUISINES") {
              if (element1.D.trim()) {
                element1.D = element1.D.split(",");
              } else {
                element.PopularAttribs.splice(idx);
              }
            }
          });
        }
      });
      this.backupListing = JSON.stringify(this.listing);
    });
  }
  openURL(url: string) {
    window.open(url, "_blank");
  }

  filter(event: any) {
    let arr: InstacitiListings[] = JSON.parse(this.backupListing);
    if (event.target.checked && event.target.id > -1) {
      this.arrFilter.push(event.target.id);
    } else if (event.target.id > -1) {
      this.arrFilter.splice(this.arrFilter.indexOf(event.target.id), 1);
    }
    if (this.arrFilter.length) {
      this.listing = arr.filter((val) =>
        this.arrFilter.includes(val.BusinessSubCategoryID.toString())
      );
    } else {
      this.listing = arr;
    }
  }
}
